if (!customElements.get('pizzannu-copy-code')) {
  class PizzannuCopyCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-pizzannu-copy-code]');
      this.label = this.querySelector('[data-pizzannu-copy-label]');
      if (!this.button || !this.label) return;

      this.defaultLabel = this.label.textContent;
      this.button.addEventListener('click', () => this.copyCode());
    }

    async copyCode() {
      const code = this.button.dataset.pizzannuCopyCode;
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      window.clearTimeout(this.resetTimer);
      this.button.classList.add('is-copied');
      this.label.textContent = this.button.dataset.copiedLabel || 'Copied';
      this.resetTimer = window.setTimeout(() => {
        this.button.classList.remove('is-copied');
        this.label.textContent = this.defaultLabel;
      }, 2400);
    }
  }

  customElements.define('pizzannu-copy-code', PizzannuCopyCode);
}
